/**
 * Runtime configuration, read once from Vite's `import.meta.env`.
 *
 * Only `VITE_`-prefixed variables reach the client bundle (Vite's own
 * security boundary) — nothing here can ever leak a server secret, because
 * nothing here has access to one.
 */
export const env = {
  apiBaseUrl: (import.meta.env.VITE_API_BASE_URL as string | undefined) ?? 'http://localhost:3000',
  /**
   * Where the PUBLIC storefront lives (e.g. `https://souk.jibex.cloud`) — the base of the link a merchant shares. It is
   * not the dashboard's own host, so it cannot be guessed. Local development falls back to the storefront's dev port; a
   * production build with no value gets `null`, and « Partager ma boutique » then shows no link (never a wrong one).
   */
  storefrontBaseUrl:
    (import.meta.env.VITE_STOREFRONT_BASE_URL as string | undefined)?.trim() ??
    (import.meta.env.DEV ? 'http://localhost:3001' : null),
} as const;

/**
 * Whether « Mot de passe oublié ? » may promise an e-mail. FALSE until the platform sends e-mails (decision of 8 October 2026: no
 * e-mail for now): the screen then tells the truth - contact the platform - instead of a link that never arrives. A BUILD setting
 * (`VITE_EMAIL_RECOVERY_ENABLED=true`), read at call time so a test can change it; the API stays as it is either way.
 */
export function emailRecoveryEnabled(): boolean {
  return (
    ((import.meta.env.VITE_EMAIL_RECOVERY_ENABLED as string | undefined) ?? '')
      .trim()
      .toLowerCase() === 'true'
  );
}
